var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      class: [
        "lexon-chronometer-container",
        {
          "time-is-running": _vm.timeIsRunning,
          "time-is-stopped": !_vm.timeIsRunning && _vm.timeStopped,
        },
      ],
    },
    [
      _c("span", { class: [_vm.icons.hourglass, "hourglass-icon"] }),
      _c("div", { staticClass: "time-container" }, [_vm._v(_vm._s(_vm.time))]),
      _c("span", {
        class: [_vm.icons.stop, "stop-icon"],
        on: { click: _vm.showDialog },
      }),
      _c("span", {
        class: [_vm.renderIcon, "action-icon"],
        on: { click: _vm.startOrStopTime },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }